import { Box, Stack } from 'braid-design-system';
import React from 'react';

import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';

export const SkeletonUserRow = () => (
  <Box background="surface" style={{ marginBottom: '4px' }}>
    <Box paddingLeft="large" paddingY="large">
      <Stack space="small">
        <Box>
          <SkeletonBlock variant="standard" width="xsmall" height="standard" />
        </Box>
        <SkeletonBlock variant="standard" width="small" height="standard" />
      </Stack>
    </Box>
  </Box>
);
